import {useAuthStore} from "@src/stores/auth";
import {useChatSessionStore} from "@src/stores/chatSession";
import {db} from "@src/services/db";
import "@src/services/echo";

type SessionArchiveEventPayload = {
    id: number;
    is_archive: boolean;
    updated_at?: string;
};

export const ArchiveSessionListener = () => {
    const auth = useAuthStore();
    const sessionStore = useChatSessionStore();

    const userId = auth.user?.id;
    if (!userId) return;

    // @ts-ignore
    window.websockets
        .private(`user.${userId}`)
        .listen(".SessionArchiveEvent", async (event: SessionArchiveEventPayload) => {
            try {
                if (!event?.id) return;

                const id = Number(event.id);
                const archive = event.is_archive;

                //update no IndexedDB
                await db.sessions.update(id, {
                    is_archive: archive,
                    updated_at: Date.now(),
                } as any);

                // se estiver aberta, atualiza também
                if (Number((sessionStore.selectedSession as any)?.id) === id) {
                    (sessionStore.selectedSession as any).is_archive = archive;
                }
            } catch (e) {
                console.error("❌ erro no listener SessionFixedEvent", e);
            }
        });
};